'use strict';

const PASSWORD_TYPE = 'password';
const TEXT_TYPE = 'text';

/**
 * toggle input type in order to show/hide password
 */
function handleTogglePasswordClick() {
    const $this = $(this);
    const passwordInput = $this.siblings('input').first();
    const eyeClosed = $this.find('.eye-closed'); // eye-closed icon is shown based on the toggle-password action being handled
    const eyeOpen = $this.find('.eye-open'); // eye-open icon is shown based on the toggle-password action being handled

    if (passwordInput.prop('type') === PASSWORD_TYPE) {
        passwordInput.prop('type', TEXT_TYPE);
        eyeOpen.addClass('d-none');
        eyeClosed.removeClass('d-none');
    }
    else {
        passwordInput.prop('type', PASSWORD_TYPE);
        eyeOpen.removeClass('d-none');
        eyeClosed.addClass('d-none');
    }
}

/**
 * Listener for toggle password icon
 */
function togglePassword() {
    $('.toggle-password').on('click', handleTogglePasswordClick);
}

module.exports = {
    togglePassword
};
